// import React from "react";
import './DocumentRequired.css'
import loanRequirements from './docData';




import React, { useState } from 'react';
import {
    User,
    TrendingUp,
    Building,
    Flag,
    DollarSign,
    Globe,
    CreditCard,
    Fingerprint,
    FileText,
    Landmark,
    Receipt
} from 'lucide-react';

export default function DocumentsAndEligibility() {
    const [activeTab, setActiveTab] = useState('Personal Loan');

    const eligibilityCriteria = [
        {
            icon: '/assets/img/Layer_1 (11).png',
            title: "Age",
            value: "21 - 58 yrs",
            mobileValue: "21 - 60 yrs"
        },
        {
            icon: '/assets/img/Layer_1 (12).png',
            title: "Credit Score",
            value: "> 650"
        },
        {
            icon: '/assets/img/Layer_1 (13).png',
            title: "Monthly Salary",
            value: "21 - 58 yrs"
        },
        {
            icon: '/assets/img/Layer_1 (14).png',
            title: "Serviceable Area",
            value: "Metro Cities"
        },
        {
            icon: '/assets/img/Layer_1 (15).png',
            title: "Nationality",
            value: "Indian"
        },
        {
            icon: '/assets/img/Layer_1 (16).png',
            title: "Mode",
            value: "Online"
        }
    ];

    const documents = [
        {
            icon: <CreditCard className="w-5 h-5" />,
            title: "PAN Card"
        },
        {
            icon: <Fingerprint className="w-5 h-5" />,
            title: "Aadhar Card"
        },
        {
            icon: <FileText className="w-5 h-5" />,
            title: "Electricity Bill"
        },
        {
            icon: <Landmark className="w-5 h-5" />,
            title: "Last 3 Months Bank Statement"
        },
        {
            icon: <Receipt className="w-5 h-5" />,
            title: "Last 3 Months Salary Slips"
        }
    ];

    return (
        <div className="min-h-screen   document-background text-white relative overflow-hidden sm:py-[60px] sm:px-[100px]">
            {/* Background Grid Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0" style={{
                    backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
                           linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
                    backgroundSize: '50px 50px'
                }}></div>
            </div>

            <img src='/assets/img/6fdcd2efa6f5b6a0f82607d1a7abf7394ccde044.png'
                className='absolute  h-[255px] w-[255px] top-[-45px] right-[20px] sm:h-[295px] sm:w-[295px] sm:right-[500px] sm:top-[-16px] brightness-[0.4] z-0'
            />

            <div className="relative z-10 p-4 lg:p-8">
                {/* Header */}
                <div className="text-center mb-8 lg:mb-12">
                    <h1 style={{ fontFamily: 'myFirstFont' }} className="w-full px-auto [@media(max-width:340px)]:text-[25px] text-[30px]   sm:w-auto sm:text-center sm:text-[45px] lg:text-[60px]  mb-6 lg:mb-8">
                        Documents Required <br className=" sm:block" />
                        <span className=" lg:inline"> and </span>Eligibility Criteria
                    </h1>

                    {/* Tab Navigation */}
                    <div style={{ fontFamily: "Atkinson-regular" }} className="w-full pt-3  flex  justify-center gap-2 lg:gap-4 z-[900]">
                        {['Personal Loan', 'Business Loan', 'PayOff'].map((tab) => (
                            <button
                                key={tab}
                                onClick={() =>{
                                    console.log(tab+" clicked ")
                                    setActiveTab(tab)
                                } }
                                className={`[@media(max-width:340px)]:py-1 px-3 lg:px-6 py-2 sm:py-5 rounded-full [@media(max-width:340px)]:text-[10px] text-sm lg:text-xl font-medium  active:scale-95 ${activeTab === tab
                                        ? 'bg-green-400 text-green-900 shadow-lg'
                                        : 'bg-transparent border border-white/30 hover:bg-white'
                                    }`}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>

                </div>

                {/* Mobile Layout */}
                <div className="lg:hidden space-y-8">
                    {/* Eligibility Criteria - Mobile */}
                    <div>
                        <h2 style={{ fontFamily: "Atkinson-regular" }} className="[@media(max-width:340px)]:text-lg text-xl w-full border-b-[1px] pb-2  border-green-700 font-semibold mb-10">Eligibility Criteria</h2>
                        <div className="grid grid-cols-2 gap-3">
                            {loanRequirements[activeTab].eligibilityCriteria.map((criteria, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col gap-8 bg-white/10 backdrop-blur-[2px] rounded-2xl p-[20px] border-[2px] border-[#12F280]/10 hover:bg-white/15 transition-all duration-300 hover:scale-[102%]"
                                >
                                    <img src={criteria.icon} className='w-[20px] mix-blend-multiply z-0 ' />
                                    <div style={{ fontFamily: "Atkinson-regular" }} className=''>
                                        <h3 className=" text-green-300 [@media(max-width:340px)]:text-[13px]  text-[20px] ">{criteria.title}</h3>
                                        <p className="text-green-300 [@media(max-width:340px)]:text-[12px] text-[18px] bg-blend-overlay">{criteria.value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Documents Required - Mobile */}
                    <div>
                        <h2 style={{ fontFamily: "Atkinson-regular" }} className=" [@media(max-width:340px)]:text-lg text-xl w-full border-b-[1px] pb-2  border-green-700 font-semibold mb-10">Documents Required</h2>
                        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border-[1px] border-[#12F280]/10 ">
                            <div className="space-y-0">
                                {loanRequirements[activeTab].documents.map((doc, index) => (
                                    <div key={index}>
                                        <div className="flex items-center gap-3 p-3 hover:bg-white/10 transition-all duration-300">
                                            <div className="text-green-300">
                                                {doc.icon}
                                            </div>
                                            <span style={{ fontFamily: "Atkinson-regular" }} className="[@media(max-width:340px)]:text-[13px] [@media(max-width:340px)]:leading-[1] text[18px]">{doc.title}</span>
                                        </div>
                                        {index < documents.length - 1 && (
                                            <hr className="border-white/20" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Desktop Layout */}
                <div className="hidden lg:grid lg:grid-cols-5 lg:gap-0">
                    {/* Eligibility Criteria - Desktop */}
                    <div className='col-span-3'>
                        <h2 style={{ fontFamily: "Atkinson-regular" }} className="text-2xl font-semibold mb-8 w-full border-b-[1px] border-green-700 pb-2">Eligibility Criteria</h2>
                        <div className="grid grid-cols-3 gap-2 ">
                            {loanRequirements[activeTab].eligibilityCriteria.map((criteria, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col gap-8 bg-white/10 backdrop-blur-sm rounded-2xl p-[20px] border-[2px] border-[#12F280]/10 hover:bg-white/15 transition-all duration-300 hover:scale-[102%]"
                                >
                                    <img src={criteria.icon} className='w-[20px] mix-blend-multiply z-0 ' />
                                    <div style={{ fontFamily: "Atkinson-regular" }} className=''>
                                        <h3 className="font-semibold text-[18px] ">{criteria.title}</h3>
                                        <p className="text-green-200 text-[18px]">{criteria.value}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Documents Required - Desktop */}
                    <div className='col-span-2'>
                        <h2 style={{ fontFamily: "Atkinson-regular" }} className="text-2xl font-semibold mb-8 w-full border-b-[1px] border-green-700 pb-2 pl-12">Documents Required</h2>
                        <div className="bg-white/10 backdrop-blur-sm w-[95%] rounded-2xl ml-10 mt-4 p-2 border-green-500/60 border-1 ">
                            <div className="space-y-0 pl-5 w-[85%] ">
                                {loanRequirements[activeTab].documents.map((doc, index) => (
                                    <div key={index}>
                                        <div className="flex items-center gap-4 p-2  hover:bg-white/10 transition-all duration-300">
                                            <div className="text-green-300 bg-white/10 p-2.5 rounded-lg">
                                                {doc.icon}
                                            </div>
                                            <span style={{ fontFamily: "Atkinson-regular" }} className="text-[18px]">{doc.title}</span>
                                        </div>
                                        {index < documents.length - 1 && (
                                            <hr className="border-white/20" />
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Decorative Elements */}
             
            </div>
        </div>
    );
}